<template>
  <div class="absolute top-0 left-0 w-full h-full z-60 bg-black/45">
    <div class="w-full h-full relative flex items-center justify-center p-4">
      <div class="w-full max-w-md rounded-md bg-white flex flex-col">
        <div class="relative">
          <button
            type="button"
            class="absolute top-0 left-2 my-2 rounded-full p-1 text-md border-2 w-auto"
            @click="closeModal()"
          >
            <IconX class="w-4 h-4"></IconX>
          </button>

          <h1 class="text-md text-center py-2">
            {{ t("itinerary.customer.title", "Formulario de cliente") }}
          </h1>
        </div>

        <form
          @submit.prevent="action()"
          class="flex flex-col gap-y-4 justify-center px-4 border-gray-200 rounded-lg p-2 bg-eblack-100/70"
        >
          <div class="flex flex-col gap-y-2">
            <label for="name" class="text-sm md:text-md">
              {{ t("itinerary.customer.identification", "Identificación") }}
            </label>
            <input
              type="text"
              name="name"
              class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
              placeholder="0000000"
              v-bind:class="{
                'ring-red-400': errors.length > 0 && errors.find((e) => e.dni),
              }"
              v-model="form.dni"
              :disabled="viewClicked"
            />
            <p
              class="text-xs md:text-sm text-red-400 pl-2"
              v-if="errors.length > 0 && errors.find((e) => e.dni)"
            >
              {{ errors.find((e) => e.dni).dni }}
            </p>
          </div>

          <div class="flex flex-col gap-y-2">
            <label for="name" class="text-sm md:text-md">
              {{ t("itinerary.customer.first_name", "Nombre") }}
            </label>
            <input
              type="text"
              name="name"
              class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
              :placeholder="$t('admin.auto.emanta')"
              v-bind:class="{
                'ring-red-400': errors.length > 0 && errors.find((e) => e.name),
              }"
              v-model="form.name"
              :disabled="viewClicked"
            />
            <p
              class="text-xs md:text-sm text-red-400 pl-2"
              v-if="errors.length > 0 && errors.find((e) => e.name)"
            >
              {{ errors.find((e) => e.name).name }}
            </p>
          </div>

          <div class="flex flex-col gap-y-2">
            <label for="last_name" class="text-sm md:text-md">
              {{ t("itinerary.customer.last_name", "Apellidos") }}
            </label>
            <input
              type="text"
              name="last_name"
              class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
              :placeholder="$t('admin.auto.emanta')"
              v-bind:class="{
                'ring-red-400':
                  errors.length > 0 && errors.find((e) => e.last_name),
              }"
              v-model="form.last_name"
              :disabled="viewClicked"
            />
            <p
              class="text-xs md:text-sm text-red-400 pl-2"
              v-if="errors.length > 0 && errors.find((e) => e.last_name)"
            >
              {{ errors.find((e) => e.last_name).last_name }}
            </p>
          </div>

          <div class="flex flex-col gap-y-2">
            <label for="email" class="text-sm md:text-md">
              {{ t("itinerary.customer.email", "Correo") }}
            </label>
            <input
              type="email"
              name="email"
              class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
              placeholder="emanta@emanta.com"
              v-bind:class="{
                'ring-red-400':
                  errors.length > 0 && errors.find((e) => e.email),
              }"
              v-model="form.email"
              :disabled="viewClicked"
            />
            <p
              class="text-xs md:text-sm text-red-400 pl-2"
              v-if="errors.length > 0 && errors.find((e) => e.email)"
            >
              {{ errors.find((e) => e.email).email }}
            </p>
          </div>

          <div class="flex flex-col gap-y-2">
            <label for="country" class="text-sm md:text-md">
              {{ t("itinerary.customer.country", "País") }}
            </label>
            <select
              name="country"
              class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
              v-bind:class="{
                'ring-red-400':
                  errors.length > 0 && errors.find((e) => e.country),
              }"
              v-model="form.country"
              :disabled="viewClicked"
            >
              <option value="">
                {{ t("itinerary.customer.country_placeholder", "--- Seleccione el país ---") }}
              </option>
              <option value="CR">{{ $t("admin.auto.costa_rica") }}</option>
              <option value="MX">{{ $t("admin.auto.mexico") }}</option>
              <option value="US">{{ $t("admin.auto.estados_unidos") }}</option>
            </select>
            <p
              class="text-xs md:text-sm text-red-400 pl-2"
              v-if="errors.length > 0 && errors.find((e) => e.country)"
            >
              {{ errors.find((e) => e.country).country }}
            </p>
          </div>

          <div class="flex flex-col gap-y-2">
            <label for="whatsapp_phone" class="text-sm md:text-md"
              >{{ t("itinerary.customer.whatsapp", "Teléfono de WhatsApp") }}</label
            >
            <PhoneInput
              v-model="form.whatsapp_phone"
              name="whatsapp_phone"
              :default-country="form.country || 'CR'"
              :invalid="
                errors.length > 0 &&
                Boolean(errors.find((e) => e.whatsapp_phone))
              "
              :disabled="viewClicked"
            />
            <p
              class="text-xs md:text-sm text-red-400 pl-2"
              v-if="errors.length > 0 && errors.find((e) => e.whatsapp_phone)"
            >
              {{ errors.find((e) => e.whatsapp_phone).whatsapp_phone }}
            </p>
          </div>

          <div class="flex" v-if="!viewClicked">
            <button
              type="submit"
              class="px-4 py-1.5 rounded-lg bg-green-500 text-white cursor-pointer"
            >
              {{ button_text }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import customerRequests from "@/services/admin/customer-service";
import { useToast } from "vue-toastification";
import { IconX } from "@tabler/icons-vue";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import { useItineraryI18n } from "@/domains/itinerary/composables";
export default {
  props: [
    "handleShowCustomerModal",
    "handleSetNewCustomer",
    "initialCustomerName",
    "initialCustomerLastName",
  ],
  name: "CustomerModal",
  setup() {
    const { t } = useItineraryI18n();
    return { t };
  },
  data() {
    return {
      viewClicked: false,
      button_text: "Guardar",
      form: {
        dni: "",
        name: "",
        last_name: "",
        email: "",
        country: "",
        whatsapp_phone: "",
      },
      errors: [],
      toast: useToast(),
      loading: false,
    };
  },
  components: {
    IconX,
    PhoneInput,
  },
  watch: {
    initialCustomerName() {
      this.applyInitialCustomerCandidate();
    },
    initialCustomerLastName() {
      this.applyInitialCustomerCandidate();
    },
  },
  mounted() {
    this.applyInitialCustomerCandidate();
  },
  methods: {
    action() {
      this.loading = true;
      this.button_text = this.t("itinerary.actions.saving", "Guardando...");
      this.save();
    },
    save() {
      customerRequests
        .save(this.form)
        .then((res) => {
          if (res.status == 201) {
            let { data } = res;
            this.resetForm();
            this.closeModal();
            this.toast.success(
              this.t(
                "itinerary.customer.save_success",
                "Cliente guardado correctamente",
              ),
              {
                timeout: 3000,
                position: "top-right",
              },
            );
            this.button_text = this.t("itinerary.actions.save", "Guardar");
            this.loading = false;
            setTimeout(() => {
              this.handleSetNewCustomer(data);
            }, 200);
          }
        })
        .catch((error) => {
          let response = error.response;
          if (response) {
            let { data } = response;
            let message = data.message;
            this.errors = message;
          }
          this.button_text = this.t("itinerary.actions.save", "Guardar");
          this.loading = false;
        });
    },
    resetForm() {
      this.form = {
        dni: "",
        name: "",
        last_name: "",
        email: "",
        country: "",
        whatsapp_phone: "",
      };
      this.button_text = this.t("itinerary.actions.save", "Guardar");
      this.applyInitialCustomerCandidate();
    },
    applyInitialCustomerCandidate() {
      if (this.initialCustomerName && !this.form.name) {
        this.form.name = this.initialCustomerName;
      }
      if (this.initialCustomerLastName && !this.form.last_name) {
        this.form.last_name = this.initialCustomerLastName;
      }
    },
    closeModal() {
      this.handleShowCustomerModal(true);
    },
  },
};
</script>

<style lang="scss" scoped></style>
